const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^\+?[0-9()\-\s]+$/;

// Basic shape check (local@domain.tld) - not full RFC 5322 validation.
export function isValidEmail(value) {
  return EMAIL_PATTERN.test(value.trim());
}

// Allows +, digits, spaces, hyphens and parentheses, with 8-15 digits - covers AU landline/mobile formats.
export function isValidPhone(value) {
  const trimmed = value.trim();
  const digitCount = trimmed.replace(/[^0-9]/g, "").length;
  return PHONE_PATTERN.test(trimmed) && digitCount >= 8 && digitCount <= 15;
}

// Today's date as YYYY-MM-DD, matching the value format of a native date input.
export function todayIsoDate() {
  return new Date().toISOString().slice(0, 10);
}

// True when an ISO date string (YYYY-MM-DD) is later than today.
export function isFutureIsoDate(value) {
  return value !== "" && value > todayIsoDate();
}
